(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/components/info-card.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/components/info-card.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  RibbonCorner
} = svs.ui.ReactRibbon;
const {
  trackPlay
} = svs.eInstant.tracking;
const {
  Card
} = svs.ui.ReactCard;
const {
  useHistory
} = ReactRouterDOM;
const {
  Image
} = svs.content.image_v2;
const {
  validateGameConfig
} = svs.eInstant.util;
const InfoCard = _ref => {
  let {
    ticketConfig: game
  } = _ref;
  const {
    ButtonsBlock
  } = svs.eInstant.shared.components;
  const history = useHistory();
  if (!validateGameConfig(game)) return null;
  const handleClickPlay = e => {
    if (svs.tur.PauseCheck.isBlocked()) {
      svs.tur.apierrors.showErrorMessage({
        response: {
          error: {
            code: 1019
          }
        }
      });
      return;
    }
    e.preventDefault();
    trackPlay(game.name, false);
    history.push("".concat(game.playUrl, "?returnUrl=").concat(encodeURIComponent(location.pathname)));
  };
  const handleClickDemoPlay = e => {
    e.preventDefault();
    trackPlay(game.name, true);
    history.push("".concat(game.demoUrl, "?returnUrl=").concat(encodeURIComponent(location.pathname)));
  };
  const previewImage = game.gamePreview || game.imageBackground;
  return React.createElement("div", {
    className: "einstant-info-card-wrapper w100",
    "data-testid": "featured-game-mobile"
  }, React.createElement(Card, {
    className: "f-body margin-h-1 margin-v-1"
  }, React.createElement(React.Fragment, null, React.createElement("div", {
    className: "u-flex u-flex-align-items-center u-flex-justify-content-center relative einstant-info-card-background"
  }, React.createElement(Image, {
    image: _objectSpread(_objectSpread({}, previewImage), {}, {
      fitWrapper: true
    }),
    loadingLazy: true
  }), game.logotype && React.createElement(Image, {
    cssSelectors: "padding-half",
    image: game.logotype,
    loadingLazy: true
  })), game.badge && React.createElement(RibbonCorner, {
    className: "ribbon-corner-branding-fler-lotter",
    size: 500
  }, game.badge), React.createElement("div", {
    className: "u-flex u-flex-column u-flex-justify-content-between u-flex-align-items-center padding-1 bg-fler-lotter-new-500"
  }, React.createElement("h2", {
    className: "h2 align-center fc-fler-lotter-new-300 margin-bottom-half"
  }, game.name), React.createElement("div", {
    className: "margin-bottom-1 u-flex u-flex-column u-flex-align-items-center align-center"
  }, game.tags.length > 0 && React.createElement("p", {
    className: "fc-fler-lotter-new-300 margin-bottom-1 f-400 clip tickets-einstant-info-card-tags align-center"
  }, game.tags.join(', ')), game.description && React.createElement("p", {
    className: "p fc-fler-lotter-new-400 clip tickets-einstant-info-card-description align-center"
  }, game.description)), React.createElement("div", {
    className: "w100"
  }, React.createElement(ButtonsBlock, {
    game: game,
    onDemoClick: handleClickDemoPlay,
    onPlayClick: handleClickPlay
  }), React.createElement("div", {
    className: "u-bottom-0 w100"
  }, React.createElement("div", {
    className: "u-flex u-flex-row u-flex-align-items-center u-flex-justify-content-between fc-fler-lotter-new-300"
  }, React.createElement("div", {
    className: "u-flex u-flex-column u-flex-align-items-center"
  }, React.createElement("span", {
    className: "f-100"
  }, "Insats"), React.createElement("span", {
    className: "f-bold"
  }, game.maxPrice ? "".concat(game.minPrice, " - ").concat(game.maxPrice, " kr") : "".concat(game.minPrice, " kr"))), React.createElement("div", {
    className: "u-flex u-flex-column u-flex-align-items-center"
  }, React.createElement("span", {
    className: "f-100"
  }, "Maxvinst"), React.createElement("span", {
    className: "f-bold"
  }, "".concat(svs.utils.format.Currency(game.maxWin), " kr"))))))), game.imageOverlay && React.createElement("div", {
    className: "einstant-info-card-image-overlay"
  }, React.createElement(Image, {
    fit: true,
    image: _objectSpread(_objectSpread({}, game.imageOverlay), {}, {
      fitWrapper: true
    }),
    loadingLazy: true
  })))));
};
setGlobal('svs.eInstant.components.InfoCard', InfoCard);

 })(window);